export default "__VITE_ASSET__D7qhlC2R__"